module.exports = __webpack_public_path__ + "img/icon-ai.a92108d5.png";